import React from 'react';
import SuiviHeader from '../../../composants/SuiviHeader/SuiviHeader';
import { getStatusColor } from '../../../utils/entityUtils';
import { CommandeBCI } from '../types';

interface CommandeHeaderProps {
  titre: string;
  sousTitre: string;
  subtitle: string;
  commande: CommandeBCI;
  backgroundImage?: string;
}

// Banniere prestataire-BC : delegue au generique SuiviHeader (meme composant et meme rendu DOM
// que la case acheteur operation-bc, config source="BCI") pour une parite VISUELLE exacte.
// SuiviHeader gere EN INTERNE l'expiration (source="BCI", statusId=9), le libelle "À relancer"
// (statut 12) et le chrono (statut 11) — exactement la logique deja reproduite dans le domaine
// commandeStatus. Le libelle/couleur du statut viennent du nom + getStatusColor (id-based cote
// expiration via statusId). On garde les props existantes (titre/sousTitre/subtitle/commande/
// backgroundImage) : le shell appelant reste inchange.
const CommandeHeader: React.FC<CommandeHeaderProps> = ({
  titre,
  sousTitre,
  subtitle,
  commande,
  backgroundImage,
}) => (
  <SuiviHeader
    titre={titre}
    sousTitre={sousTitre}
    subtitle={subtitle}
    status={commande.status?.nom || 'Statut inconnu'}
    statusColor={getStatusColor(commande.status?.nom || '')}
    delais={commande.expire_at ?? undefined}
    backgroundImage={backgroundImage}
    source="BCI"
    statusId={commande.status?.id}
  />
);

export default CommandeHeader;
